<template style="height: 100%;">
  <div class="examine">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="待处理" name="first">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号" width="60px" align="left">
            <template slot-scope="scope" center>
              {{ (currentPage1 - 1) * 5 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="Creator" label="辅导员" width="75"></el-table-column>
          <el-table-column label="测评主题">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p >{{scope.row.PublishSubject}}</p>
                <div slot="reference" class="paperList">
                  {{ scope.row.PublishSubject}}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="PublishedPaperArray" label="测评量表">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p  v-for="(item,i) in scope.row.PublishedPaperArray" :key="i" style="padding-top: 6px">{{item}}</p>
                <div slot="reference" class="paperList">
                  {{ scope.row.PublishedPaperArray[0] }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="PublishedPersonArray" label="测评对象"></el-table-column>
          <el-table-column prop="CreatedDate" label="创建时间"></el-table-column>
          <el-table-column prop="name" label="审批状态">
            <template slot-scope="scope">
            <span v-if="scope.row.status == 1"
                  style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">待初审</span>
              <span v-else-if="scope.row.status == 2"
                    style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">待复核</span>
              <span v-else-if="scope.row.status == 3"
                    style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">待终审</span>
              <span v-else-if="scope.row.status == 4"
                    style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">初审驳回</span>
              <span v-else-if="scope.row.status == 5"
                    style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">复核驳回</span>
              <span v-else-if="scope.row.status == 6"
                    style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">终审驳回</span>
              <span v-else
                    style="color: #fff; background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;">审核通过</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">


              <el-button v-if="(scope.row.status == 1 && pdroleida )||(scope.row.status == 2 && pdroleidb)||(scope.row.status == 3 && pdroleidc)" type="text" @click="Examine(scope.row,2)">
                审核
              </el-button>
              <el-button v-else type="text" @click="Examine(scope.row,1)">
                详情
              </el-button>
<!--              <span style="cursor:pointer;color: #409EFF;padding: 5px;" @click="looks(scope)">审核</span>-->
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="tableData.length > 0">
          <el-pagination @current-change="loading" :current-page.sync="currentPage1" :page-size="5" layout="total, prev, pager, next" :total="Counts"></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane label="往期记录" name="second">
        <el-table :data="tableData2" style="width: 100%">
          <el-table-column label="序号" width="60px" align="left">
            <template slot-scope="scope" center>
              {{ (currentPage2 - 1) * 5 + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="Creator" label="辅导员" width="75"></el-table-column>
          <el-table-column label="测评主题">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p >{{scope.row.PublishSubject}}</p>
                <div slot="reference" class="paperList">
                  {{ scope.row.PublishSubject}}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="PublishedPaperArray" label="测评量表">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p  v-for="(item,i) in scope.row.PublishedPaperArray" :key="i" style="padding-top: 6px">{{item}}</p>
                <div slot="reference" class="paperList">
                  {{ scope.row.PublishedPaperArray[0] }}
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="PublishedPersonArray" label="测评对象"></el-table-column>
          <el-table-column prop="CreatedDate" label="创建时间"></el-table-column>
          <el-table-column prop="name" label="审批状态">
            <template slot-scope="scope">
            <span v-if="scope.row.status == 1"
                  style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">待初审</span>
              <span v-else-if="scope.row.status == 2"
                    style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">待复核</span>
              <span v-else-if="scope.row.status == 3"
                    style="color: #fff;background-color: rgba(0, 136, 255, 1);padding: 8px;border-radius: 12px;">待终审</span>
              <span v-else-if="scope.row.status == 4"
                    style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">初审驳回</span>
              <span v-else-if="scope.row.status == 5"
                    style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">复核驳回</span>
              <span v-else-if="scope.row.status == 6"
                    style="color: #fff;background-color: rgba(242, 75, 78, 1);padding: 8px;border-radius: 12px;">终审驳回</span>
              <span v-else
                    style="color: #fff; background-color: rgba(21, 191, 109, 1);padding: 8px;border-radius: 12px;">审核通过</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" v-if="tableData2.length > 0">
          <el-pagination @current-change="loadingPrevious" :current-page.sync="currentPage2" :page-size="5" layout="total, prev, pager, next" :total="Counts2"></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="测试审批" :visible.sync="dialogFormVisible" width="550px">
      <el-descriptions class="margin-top" title="" :column="1" :size="size" border>
        <el-descriptions-item>
          <template slot="label">
            辅导员:
          </template>
          {{examineItem.Creator}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            测评主题:
          </template>
          {{examineItem.PublishSubject}}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            测评量表:
          </template>
          <p  v-for="(item,i) in examineItem.PublishedPaperArray" :key="i" style="padding-top: 6px">{{item}}</p>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            测评对象:
          </template>
          <p  v-for="(item,i) in examineItem.PublishedPersonArray" :key="i" style="padding-top: 6px">{{item}}</p>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            测评时间:
          </template>
          {{examineItem.ValidStartDate}} 至 {{examineItem.ValidEndDate}}
        </el-descriptions-item>
      </el-descriptions>
      <el-form :model="form">
        <el-form-item label="审批状态" :label-width="formLabelWidth">
          <div style="height: 190px;padding-top: 10px">
            <el-steps direction="vertical" :active="examineItem.status>3?examineItem.status-4:examineItem.status-1">
              <el-step :title="examineItem.status == 1 ? '风险监控员(审核中)':examineItem.status == 4 ? examineItem.riskMonitor+'(审核驳回)':examineItem.riskMonitor+'(审核通过)'"
                       :description="examineItem.riskMonitorCheckTimeStr"></el-step>
              <el-step :title="(examineItem.status == 1 || examineItem.status == 4)?'危机主管':examineItem.status == 2?'危机主管(审核中)':examineItem.status == 5?examineItem.criAdmin+'(已驳回)':examineItem.criAdmin+'(审核通过)'"
                       :description="examineItem.criAdminCheckTimeStr"></el-step>
              <el-step :title="examineItem.status == 3?'中心主任(审核中)':examineItem.status == 6?examineItem.centerDirector+'(已驳回)':examineItem.status == 7?examineItem.centerDirector+'(审核通过)':'中心主任'"
                       :description="examineItem.centerDirectorCheckTimeStr"></el-step>
            </el-steps>
          </div>
        </el-form-item>
        <el-form-item label="拒绝原因" :label-width="formLabelWidth" v-if="examineItem.isDetail == 2">
          <el-input type="textarea" v-model="rejectCause" autocomplete="off" @change="setInformation"></el-input>
          <div class="error" v-model="errorInformation">{{this.rejectCause == ''?this.errorInformation:''}}</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer"  v-if="examineItem.isDetail == 2">
        <el-button type="primary" @click="agreeSubmission(examineItem.PublishID)" :loading="agreeload" v-if="rejectCause == ''">同 意</el-button>
        <el-button type="primary" @click="rejectSubmission(examineItem.PublishID,rejectCause)" plain>拒 绝</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>

      </div>
      <div slot="footer" class="dialog-footer"  v-if="examineItem.isDetail == 1">
        <el-button @click="dialogFormVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pdroleida: this.Global.pdroleid(1069),
      pdroleidb: this.Global.pdroleid(1068),
      pdroleidc: this.Global.pdroleid(1070),
      RoleID:sessionStorage.getItem('RoleID'),
      activeName: 'first',
      Counts:0,
      Counts2:0,
      wloadings:true,
      tableData: [],
      tableData2: [],
      dialogFormVisible: false,
      currentPage1:1,
      currentPage2:1,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rejectCause:'',
      errorInformation:'',
      formLabelWidth: '80px',
      size: '',
      examineItem:{

      },
      agreeload:false
    };
  },
  mounted() {
    this.RoleID = sessionStorage.getItem('RoleID');
  },
  created() {
    this.loading(1);
    this.loadingPrevious(1);
  },
  methods: {
    setInformation(){
      if(this.rejectCause != ''){
        this.setInformation(
            errorInformation = '',
        );
      }
    },
    agreeSubmission(PublishID){
      this.agreeload=true;
      //审核结果提交
      this.$Http_Post("ScaleIssue/AuditDeptScaleIssue",{
        PublishID:PublishID,
      }).then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  console.warn(res.Data);
                }
                this.agreeload=false;
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err.message,
                });
                this.agreeload=false;
              });
      //关闭对话框
      this.dialogFormVisible = false;
      //刷新页面
      location.reload();
    },
    rejectSubmission(PublishID,rejectCause){
      if(rejectCause==''){
        this.errorInformation = '请填写拒绝原因！';
      }else {
        //审核结果提交
        this.$Http_Post("ScaleIssue/RejectDeptScaleIssue",{
          PublishID:PublishID,
          RefuseReason:rejectCause,
        })
                .then((res) => {
                  if (res.Code == 200 || res.Code == 0) {
                    console.warn(res.Data);
                  }
                })
                .catch((err) => {
                  this.$message({
                    type: "error",
                    message: err.message,
                  });
                });
        //关闭对话框
        this.dialogFormVisible = false;
        //刷新页面
        location.reload();
      }
    },
    Examine(item,isDetail){
      this.dialogFormVisible = true;
      this.examineItem = item;
      this.examineItem.isDetail = isDetail;
    },
    handleClick(tab, event) {
    },
    loading(num) {
      var from = {
        PageSize: "5",
        PageIndex: num,
      }
      this.$Http_Post("ScaleIssue/QueryDeptScaleIssueList",from)
              .then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.tableData = res.Data;
                  // debugger;
                  // for(let i=0;i<res.Data.length;i++){
                  //   this.tableData[i].PublishedPaperArray = res.Data[i].PublishedPaperArray.join(" || ");
                  // }
                  // console.warn(res.Data)
                  this.Counts = Number(res.Counts);
                  this.wloadings = true;
                } else {
                  this.wloadings = false;
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err.message,
                });
              });
    },
    loadingPrevious(num) {
      var from = {
        PageSize: "5",
        PageIndex: num,
      }
      this.$Http_Post("ScaleIssue/QueryDeptScaleIssueListHistory",from)
              .then((res) => {
                if (res.Code == 200 || res.Code == 0) {
                  this.tableData2 = res.Data;
                  // debugger;
                  // for(let i=0;i<res.Data.length;i++){
                  //   this.tableData[i].PublishedPaperArray = res.Data[i].PublishedPaperArray.join(" || ");
                  // }
                  // console.warn(res.Data)
                  this.Counts2 = Number(res.Counts);
                  this.wloadings = true;
                } else {
                  this.wloadings = false;
                }
              })
              .catch((err) => {
                this.$message({
                  type: "error",
                  message: err.message,
                });
              });
    },
  },
};
</script>
<style>
.examine {
  padding: 15px;
  height: 100%;
  background-color: #fff;
  overflow: auto;
}
.examine .error {
  color: #f30000;
  padding-top: 5px;
  height: 36px;
}
.examine .el-input__inner {
  width: 360px;
}

.el-step.is-vertical .el-step__title {
  font-size: 14px;
  line-height: 24px;
  padding-bottom: 8px;
}
.el-step.is-vertical .el-step__line {
  width: 2px;
  top: 18px;
  bottom: 0;
  left: 11px;
}
.el-step__icon-inner {
  display: none;
}
.el-step__icon.is-text {
  border-radius: 50%;
  border: 4px solid;
  border-color: inherit;
}
.el-step__icon {
  position: relative;
  z-index: 1;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  top:-10px;
  left: 8px;
  width: 8px;
  height: 8px;
}
.examine .paperList {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.el-step__title.is-finish {
  color: #666;
}
.el-step__description.is-finish {
  color: #999;
}
.el-step__head.is-finish {
  border-color: #666;
}

.el-step__title.is-process {
  font-weight: 700;
  color: #0088ff;
}
.el-step__description.is-process {
  color: #999;
}
.el-step__head.is-process {
  border-color: #0088ff;
}
</style>
